import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <div className="logo-container">
            <img
              src="../../assets/images/logo.png"
              alt="DJV4 Logo"
              className="footer-logo"
            />
          </div>
          <div className="footer-info">
            <span className="brand-name">Djv4</span>
            <a href="mailto:djv4team@gmail.com" className="footer-support">
              DJV4team@gmail.com
            </a>
          </div>
        </div>
        <div className="footer-right">
          <span className="footer-text">© 2025 Djv4. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
